import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer-premium">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <div className="footer-logo">
                            <span className="logo-icon">🕉️</span>
                            <div className="brand-text-group">
                                <span className="logo-text-footer">Snakk med Krishna</span>
                                <span className="trademark">®</span>
                            </div>
                        </div>
                        <p>Gammel visdom kombinert med moderne teknologi</p>
                    </div>
                    <div className="footer-links">
                        <Link to="/about">Om oss</Link>
                        <Link to="/pricing">Priser</Link>
                        <Link to="/contact">Kontakt</Link>
                        <Link to="/privacy">Personvern</Link>
                        <Link to="/refund">Refusjon</Link>
                        <Link to="/login">Logg inn</Link>
                        <Link to="/signup">Registrer deg</Link>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>© 2026 Snakk med Krishna<span className="trademark" style={{ verticalAlign: 'middle', fontSize: '0.8em' }}>®</span>. Alle rettigheter reservert.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
